export default "__VITE_ASSET__Aa$Xt0Io__"